/**
 * Logger utility for controlled console output
 *
 * - logger.log() only works in development mode
 * - logger.error() and logger.warn() always work
 * - Prevents console.log from appearing in production builds
 */
/* eslint-disable no-console */

const isDev = import.meta.env.DEV;

export const logger = {
  /**
   * Log message (only in development)
   * @param {...any} args - Arguments to log
   */
  log: (...args: unknown[]) => {
    if (isDev) {
      console.log(...args);
    }
  },

  /**
   * Log error (always enabled)
   * @param {...any} args - Arguments to log
   */
  error: (...args: unknown[]) => {
    console.error(...args);
  },

  /**
   * Log warning (always enabled)
   * @param {...any} args - Arguments to log
   */
  warn: (...args: unknown[]) => {
    console.warn(...args);
  },

  /**
   * Log info (only in development)
   * @param {...any} args - Arguments to log
   */
  info: (...args: unknown[]) => {
    if (isDev) {
      console.info(...args);
    }
  },

  /**
   * Log debug (only in development)
   * @param {...any} args - Arguments to log
   */
  debug: (...args: unknown[]) => {
    if (isDev) {
      console.debug(...args);
    }
  },
};
